import { TweenMax, Expo } from "gsap";
import * as canvastypes from "../store/modules/canvas/canvastypes";
import * as StoreUtil from "./StoreUtil";

const tweenObj = {
  scale: 1,
  x: 0,
  y: 0
};

export function animScale(
  startScale,
  endScale,
  duration = 1,
  delay = 0,
  ease = Expo.easeInOut,
  onStart
) {
  // tweenObj.scale = startScale;
  TweenMax.fromTo(
    tweenObj,
    duration,
    {
      scale: startScale
    },
    {
      onStart: onStart,
      scale: endScale,
      ease: ease,
      delay: delay,

      onUpdate: () => {
        onUpdateScale();
      },
      onComplete: () => {
        onCompleteScale();
      }
    }
  );
}
export function animOffset(
  startOffset,
  endOffset,
  duration = 1,
  delay = 0,
  ease = Expo.easeInOut
) {
  tweenObj.x = startOffset.x;
  tweenObj.y = startOffset.y;
  TweenMax.to(tweenObj, duration, {
    x: endOffset.x,
    y: endOffset.y,
    ease: ease,
    delay: delay,
    onUpdate: () => {
      setStageXY(tweenObj);
    },
    onComplete: () => {
      setStageXY(tweenObj);
    }
  });
}

function setStageScale(scale) {
  StoreUtil.setCanvasScale(scale);
}
function setStageXY(obj) {
  StoreUtil.setCanvasOffset(obj);
}
function onUpdateScale() {
  setStageScale(tweenObj.scale);
}
function onCompleteScale() {
  setStageScale(tweenObj.scale);
}
export function animStage(
  startScale,
  endScale,
  startOffset,
  endOffset,
  duration = 1
) {
  tweenObj.scale = startScale;
  tweenObj.x = startOffset.x;
  tweenObj.y = startOffset.y;
  TweenMax.to(tweenObj, duration, {
    scale: endScale,
    x: endOffset.x,
    y: endOffset.y,
    ease: Expo.easeInOut,
    onUpdate: () => {
      onUpdateStage();
    },
    onComplete: () => {
      onCompleteStage();
    }
  });
}

function onUpdateStage() {
  setStageScale(tweenObj.scale);
  setStageXY(tweenObj);
}

function onCompleteStage() {
  setStageScale(tweenObj.scale);
  setStageXY(tweenObj);
}


export function spanAnim(el, delay = 0, duration = 0.5 ){
  TweenMax.staggerFromTo(
    el,
    duration,
    { opacity: 0, y: 10 },
    { opacity: 1.0, y: 0, ease: Expo.easeOut, delay: delay },
    0.03
  );
}
